import AgoraRTC from 'agora-rtc-sdk-ng'
AgoraRTC.setLogLevel(4)

export const rtcClient = AgoraRTC.createClient({ mode: 'rtc', codec: 'vp8' })
export const liveClient = AgoraRTC.createClient({ mode: 'live', codec: 'vp8' })

const clients = {}

export function getOrCreateClient (id, mode = 'rtc', codec = 'vp8') {
  if (clients[id]) {
    return clients[id]
  }
  clients[id] = AgoraRTC.createClient({ mode: mode, codec: codec })
  return clients[id]
}

export function getClient (id, mode = 'rtc', codec = 'vp8') {
  return clients[id]
}

export function createClient (mode = 'rtc', codec = 'vp8') {
  return AgoraRTC.createClient({ mode: mode, codec: codec })
}

export function sanitiseId (id) {
  let sanitised = id.split('@').join('')
  sanitised = sanitised.split('.').join('')
  return sanitised
}

export function analyseReports (stats) {

  const packetLossPercentage = stats.packetLossRate * 1000
  const callQualityNumber = getCallQualityNumber(stats.transportDelay, packetLossPercentage)
  const callQualityText = getCallQualityText(stats.transportDelay, packetLossPercentage)

  return {
    'avgLatency': stats.transportDelay,
    'percentagePacketLoss': packetLossPercentage,
    'callQualityNumber': callQualityNumber,
    'callQualityText': callQualityText
  }
}

function getCallQualityNumber (latency, packetLoss) {
  if (packetLoss > 7 || latency > 1000) {
    return 1
  }
  if (packetLoss > 2 || latency > 750) {
    return 2
  }
  if (packetLoss > 1 || latency > 500) {
    return 3
  }
  return 4
}

function getCallQualityText (latency, packetLoss) {
  if (packetLoss > 7 || latency > 1000) {
    return 'danger'
  }
  if (packetLoss > 2 || latency > 750) {
    return 'warning'
  }
  if (packetLoss > 1 || latency > 500) {
    return 'info'
  }
  return 'success'
}

export function recordLayoutPoco (arr) {
  return JSON.parse(`[
        {
            "uid": "${arr[0]}",
            "x_axis": 0.0,
            "y_axis": 0.015,
            "width": 1.0,
            "height": 0.34,
            "render_mode": 1
        },
        {
            "uid": "${arr[1]}",
            "x_axis": 0.0,
            "y_axis": 0.355,
            "width": 1.0,
            "height": 0.34,
            "render_mode": 1
        },
        {
            "uid": "${arr[2]}",
            "x_axis": 0.0,
            "y_axis": 0.625,
            "width": 1.0,
            "height": 0.34,
            "render_mode": 1
        }
    ]`)
}

export function recordLayoutMucho (arr) {
  return `[
        {
            "uid": "${arr[0]}",
            "x_axis": 0.0,
            "y_axis": 0.015,
            "width": 1.0,
            "height": 0.34,
            "render_mode": 1
        },
        {
            "uid": "${arr[1]}",
            "x_axis": 0.0,
            "y_axis": 0.28,
            "width": 1.0,
            "height": 0.34,
            "render_mode": 1
        },
        {
            "uid": "${arr[2]}",
            "x_axis": 0.0,
            "y_axis": 0.545,
            "width": 1.0,
            "height": 0.34,
            "render_mode": 1
        }
    ]`
}
